import { BaseCrudApi } from "./abstract/base-crud.api";

export class ListsApi extends BaseCrudApi {
  constructor() {
    super('lists');
  }
}
